import { Fragment, h } from 'preact';
import { Text } from 'preact-i18n';
import * as styles from './pill.scss';
import * as globalStyles from '../../styles/global.scss';
import type { TermEntry } from '../../types/mentioned-terms';
import { useRef, useState } from 'preact/hooks';
import { Popover } from '../popover/popover';
import { MoreItemsDropdown } from './more-items-dropdown';
import { clsx } from 'clsx';

interface Props {
  terms: TermEntry[];
  onTermClick: (term: string) => void;
  activeTerm: string | null;
}
export const MoreItemsPill = ({ terms, onTermClick, activeTerm }: Props): h.JSX.Element => {
  const moreItemsButtonRef = useRef(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  function handleClick(): void {
    setIsPopoverOpen((isOpen) => !isOpen);
  }

  function handleTermClick(term: string): void {
    setIsPopoverOpen(false);
    onTermClick(term);
  }

  return (
    <Fragment>
      <button ref={moreItemsButtonRef} className={clsx(styles.more, styles.pill, isPopoverOpen ? styles.moreActive : '')} onClick={handleClick}>
        <span aria-hidden className={styles.buttonInnerSpan}>
          &middot;&middot;&middot;
        </span>
        <span className={globalStyles.visuallyHidden}>
          <Text id="taxonomyTranscript.moreTermsButtonLabel">Click to see more terms</Text>
        </span>
      </button>
      {isPopoverOpen ? (
        <Popover anchorElementRef={moreItemsButtonRef}>
          <MoreItemsDropdown activeTerm={activeTerm} terms={terms} onTermClick={handleTermClick} />
        </Popover>
      ) : null}
    </Fragment>
  );
};
